import React, { FC, useEffect, useState } from "react"
import Breadcrumb from "../../../components/common/Breadcrumbs";
import { useFindUserSettingsByGroupNameQuery } from "../../../components/common/userSetting/userSettingsApi";
import { createClickableLink } from "../../../components/common/datatable/DataTableUtils";
import { DataTable } from "../../../components/common/datatable/DataTable";
import { useFindAllRolesQuery } from "./rolesApi";
import IconButton from "../../../components/common/form/IconButton";
import { FaPlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import { SearchInputWrapper } from "../../../components/common/datatable/filter/SearchInputWrapper";

const Roles: FC = () => {

    const navigate = useNavigate()

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Roles", url: "" },

    ])

    useEffect(() => {
        document.title = "Roles";
    });

    const { data: userSettings } = useFindUserSettingsByGroupNameQuery("Role");

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
            canSort: false,
            cell: (props: any) => {
                let path = `/roles/${props.row.original.id}`;
                return createClickableLink(path, props.value, userSettings, false, "", ["ROL-R"]);
            }
        },
        {
            label: "Authority", accessor: "authorityLevel",
            canSort: false
        },
    ]

    return (

        <div className="px-5 py-5">
            <div className="flex justify-between">
                <Breadcrumb crumbs={crumbs} />
            </div>

            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useFindAllRolesQuery
                }}
                renderOptions={{
                    skipUserSettingRender: true
                }}
                buttonOptions={{
                    addButton: {
                        button: <IconButton
                            icon={<FaPlus />}
                            hasBackground={true}
                            onClick={() => {
                                navigate("/roles/create")
                            }}
                            className="h-[35px] min-w-[52px] rounded-[11px]"
                            title={"Add Role"}
                        />,
                        permissions: ["ROL-C"]
                    },
                    
                }}

            />

        </div>

    )
}
export default Roles